module.exports = __webpack_public_path__ + "img/main.37adb4c0.png";